// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { ToolsPanel } from "./tools-panel.jsx";


// Stateless components

export function StaffTools(props) {

    //
    // Render
    //

    function SimulationNotice(props) {
        var s_number = props['s_number'];
        var label = 'Simulating: ' + s_number;

        return (
            <div className="simulation-panel__simulating">
                <span className="simulation-panel__simulating__text">{label}</span>
            </div>
        );
    }
        
    function renderToolPanel(context) {
        var user_profile = context['user_personalisation'];

        if(user_profile) {
            var is_simulating = user_profile['isImpersonated'];
            var s_number = user_profile['sNumber']
            
            return (
                <div className="simulation-panel__wrapper" data-ga-label="Simulation Panel">
                    {is_simulating &&
                    <SimulationNotice s_number={s_number}  />
                    }
                    <ToolsPanel />
                </div>
            )
        }

        return null;
    }


    return (
        <PortalContext.Consumer>
            {renderToolPanel}
        </PortalContext.Consumer>     
    );
};
